import { React, createContext, useState, useContext, useEffect } from 'react'
import { useNavigate } from 'react-router-dom';
import { ApiService } from '../ApiService';
import { useProovedorData } from "./ProovedorData";

const AppContext = createContext();
export const useProveedorVisita = () => useContext(AppContext);

export const ProveedorVisita = ({ children }) => {
    const navigate = useNavigate();

    const params = new URLSearchParams(window.location.search);
    const nit = params.get('search');

    const { cacheCompany, setCacheCompany, loadImageS, loading } = useProovedorData();
    useEffect(() => {
        const token_local = String(localStorage.getItem("token"));
        if (!nit || String(nit).length < 6) navigate("/");
        if (token_local && token_local.length > 150) callInformationCompany();
    }, [nit]);

    /////////////////////////STATES///////////////////////////////////
    const [logoCompany, setLogoCompany] = useState("");
    const [themeCompany, setThemeCompany] = useState("#989d96")
    //////////////////////END STATES///////////////////////////////////

    const options = ["main", "products", "us", "publications"];

    async function callInformationCompany(type = "main") {
        if (!options.includes(type)) navigate("/");

        if (cacheCompany[nit] && cacheCompany[nit][type]) {
            if (type == "main") {
                setLogoCompany(cacheCompany[nit][type].logo);
                const root = document.documentElement;
                root.style.setProperty('--theme-visit', cacheCompany[nit][type].theme ?? '#989d96');
                setThemeCompany(cacheCompany[nit][type].theme);
            }

            const company = cacheCompany[nit] && cacheCompany[nit][type] ? cacheCompany[nit][type] : (type != "publications" ? {} : []);
            return company;
        }

        const object_urls = {
            main: `api/company/public/main?search=${nit}`,
            products: `api/company/public/product/list?search=${nit}`,
            us: `api/company/public/us?search=${nit}`,
            publications: `api/company/public/publication/list?search=${nit}`,
        };

        try {
            const url = object_urls[type];
            const data = await ApiService.fetchData(url);

            if (data) {
                if (type == "main") {
                    setLogoCompany(data.logo);

                    const root = document.documentElement;
                    root.style.setProperty('--theme-visit', data.theme ?? '#989d96');
                    setThemeCompany(data.theme ?? '#989d96');
                }

                setCacheCompany(oldData => ({
                    ...oldData,
                    [nit]: {
                        ...cacheCompany[nit],
                        [type]: data
                    }
                }));

                return data;
            } else {
                navigate("/error404");
            }
        } catch (error) {
            console.error("Error obteniendo productos:", error);
        }
    }


    return (
        <AppContext.Provider value={{ callInformationCompany, nit, logoCompany, themeCompany, loadImageS, loading }}>
            {children}
        </AppContext.Provider>
    )
}
